export default "__VITE_ASSET__DuAm0PM4__"